/**
 * ---------------------------------------------------------------------------------------------------------------------
 * Các keys lưu trữ trong storage trình duyệt --------------------------------------------------------------------------
 * ---------------------------------------------------------------------------------------------------------------------
 *
 * @author admin
 * */

export const STORAGE_KEY = {
  langDefault: 'nhanhLangDefault',

  businesses: 'businesses',
  accessToken: 'nhanhAccessToken',
  userData: 'nhanhUserData',
  profileUI: 'nhanhProfileUI',
  BUSINESS_CURRENT: 'businessCurrent',
  usr: 'usr',
  localSettings: 'localSettings',

  // Toàn bộ cấu hình giao diện Ads portal gom trong 1 object (menu, sidebar, độ rộng, dark mode, màu)
  adsProfileUi: 'adsProfileUi',
};


export const STORAGE_SETTING_UI = {
  posWrapperHorizontal: 'pos_wrapper_horizontal'
}
